// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"484":"31d6cfe0","690":"e86f3fef"}[chunkId] + ".chunk.css";
};